import '~/styles/base.css'
import '~/styles/sections/header.css'
import '~/styles/sections/announcement-bar.css'
import '~/styles/sections/footer.css'
import '~/styles/sections/cart-drawer.css'
import '~/styles/sections/product-card.css'
import '~/styles/sections/hero.css'
import '~/styles/sections/season-ribbon.css'
import '~/styles/sections/featured-collection.css'
import '~/styles/sections/editorial-quote.css'
import '~/styles/sections/shape-categories.css'
import '~/styles/sections/type-categories.css'
import '~/styles/sections/story-teaser.css'
import '~/styles/sections/press-strip.css'
import '~/styles/sections/newsletter.css'
import '~/styles/sections/main-collection.css'
import '~/styles/sections/list-collections.css'
import '~/styles/sections/main-product.css'
import '~/styles/sections/contact.css'
import '~/styles/sections/faq-accordion.css'
import '~/styles/sections/instagram-feed.css'
import '~/styles/sections/story-page.css'
import '~/styles/sections/error-404.css'
import '~/styles/sections/account.css'
import '~/styles/sections/main-search.css'
import '~/styles/sections/prose-page.css'
import '~/styles/sections/try-on.css'

import { initSmoothScroll } from '~/modules/smooth-scroll'
import { initReveal } from '~/modules/reveal'
import { initHeader } from '~/modules/header'
import { initCartDrawer } from '~/modules/cart-drawer'
import { initHero } from '~/modules/hero'
import { initFilters } from '~/modules/filters'
import { initPDP } from '~/modules/pdp'
import { initTryOn } from '~/modules/try-on'
import { initAnalytics } from '~/modules/analytics'

function boot(): void {
  initSmoothScroll()
  initReveal()
  initHeader()
  initCartDrawer()
  initHero()
  initFilters()
  initPDP()
  initTryOn()
  initAnalytics()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot)
} else {
  boot()
}
